
export const biebasic = {

  bienentitytype: {
    service: {
      name: 'bienentitytype',
      title:'BIE Entity Type',
    }
  },

  bieentrytype: {
    service:{
      name:'bieentrytype',
      title:'BIE Entry Type',
    }
  },

  bieflowtype: {
    service:{
      name:'bieflowtype',
      title:'BIE Flow Type', 
    }
  },

  bieformulascope: {
    service:{
      name:'bieformulascope',
      title:'BIE Formula Scope', 
    }
  },

  bieimportsource: {
    service:{
      name:'bieimportsource',
      title:'BIE Import Source', 
    }
  },

  bielocationtype: {
    service:{
      name:'bielocationtype',
      title:'BIE Location Type', 
    }
  },

  bieobjectivetype: {
    service:{
      name:'bieobjectivetype',
      title:'BIE Objective Type',
    }
  },

  bieperiodtype: {
    service:{
      name:'bieperiodtype',
      title:'BIE Period Type',
    }
  },

  bierelationshiptype: {
    service:{
      name:'bierelationshiptype',
      title:'BIE Relationship Type',
    }
  },

  bieresulttype: {
    service:{
      name:'bieresulttype',
      title:'BIE Result Type',
    }
  },

  biescenariotype: {
    service:{
      name:'biescenariotype',
      title:'BIE Scenario Type',
    }
  },

  biestate: {
    service:{
      name:'biestate',
      title:'BIE State',
    }
  },

  bieunit: {
    service:{
      name:'bieunit',
      title:'BIE Unit',
    }
  },

  bievaluesource: {
    service:{
      name:'bievaluesource',
      title:'BIE Value Source',
    }
  },

};
